import React from 'react';
import { BookMarkedIcon, BoxesIcon, ClipboardListIcon, ListChecksIcon, SearchCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  dictionary: BookMarkedIcon,
  exercises: ListChecksIcon,
  search: SearchCheckIcon,
  clipboard: ClipboardListIcon,
  projects: BoxesIcon
};
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-brand-navy text-white" data-id="element-27" data-mp="14sj5o9bf70zs">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="zv14j53n9q2c">
        <h2 id="bonos" className="font-display text-2xl uppercase leading-tight text-brand-yellow sm:text-4xl" data-id="element-29" data-mp="1eje2g7malizh">
          5 Bonos incluidos
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] font-medium leading-snug text-white/85" data-id="element-30" data-mp="19mdvluhmcc7b">
          Y además recibes 5 recursos prácticos — GRATIS con tu compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-31" data-mp="1jk1oeevnz9mu">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border-2 border-brand-yellow bg-white p-3 text-left" data-id="element-32" data-mp="3tr5ebxakvxqb" data-mpi={i}>
                <span className="inline-flex w-fit items-center gap-1.5 rounded bg-brand-yellow px-2 py-0.5 text-[0.6rem] font-extrabold uppercase tracking-[0.12em] text-brand-carbon" data-id="element-33" data-mp="7m0dek1k5mij">
                  <Icon size={11} data-id="element-34" data-mp="gju85qjoc83l" />
                  Bono {i + 1} — Gratis
                </span>
                <h3 className="mt-1.5 text-[0.82rem] font-extrabold uppercase leading-tight text-brand-navy" data-id="element-35" data-mp="ldezx0uoc5uc">
                  {bono.title}
                </h3>
                <p className="mt-1 text-[0.78rem] leading-snug text-brand-muted" data-id="element-36" data-mp="vatcuqhe2chw">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 text-[0.72rem] font-extrabold uppercase text-brand-blue line-through decoration-red-600 decoration-2" data-id="element-37" data-mp="10a619fnwrrml">
                  {bono.value}
                </p>
              </Reveal>;
        })}
        </ul>

        <p className="mt-3 inline-block rounded-lg border-2 border-brand-yellow bg-brand-blue px-3 py-2 text-[0.78rem] font-extrabold uppercase leading-tight text-white sm:text-sm" data-id="element-38" data-mp="kas88as2a3cc">
          💰 Valor total de los 5 bonos: {BONUS_VALUE}
          <span className="mt-0.5 block text-brand-yellow" data-id="element-39" data-mp="taf98vgvp74v">
            🔥 Hoy los 5 están incluidos gratis.
          </span>
        </p>
      </div>
    </section>;
}